import React from 'react';
import styled from 'styled-components';
import { Text } from '../components';

export const FailedContainer = styled.div`
  display: flex;
  width: 100%;
  background-color: #fdeff1;
  padding: 16px;
  border-radius: 8px;
  align-items: center;
  flex: 1;
`;

export const normalizeStatus = (status) => (status || '').trim().toLowerCase();

function Status({ status }) {
  let message = 'The WOTC form is not yet complete. Please complete and submit again.';
  if (normalizeStatus(status) === 'withdrawn') {
    message = 'This WOTC application was withdrawn. Please contact your manager.';
  } else if (normalizeStatus(status) === 'waiting for signer approval') {
    message = 'Signature incomplete. Please sign the form and submit again.';
  }
  return (
    <FailedContainer>
      <img src='/j/images/employee-onboarding/circle-exclamation.svg' />
      <Text
        style={{
          color: '#464D5D',
          fontSize: '14px',
          paddingLeft: '10px',
        }}
      >
        {message}
      </Text>
    </FailedContainer>
  );
}
export default Status;
